import { WebSocketReceiveMessage } from './web-socket-receive-message';
import { Asset } from '../../../image/dto/asset';

export class WebSocketReceiveAssetUpdated extends WebSocketReceiveMessage {
  override payload: Asset;

  override onDeserialize() {
    super.onDeserialize();
    this.payload = window?.injector?.Deserialize?.instanceOf(Asset, this.payload);
  }
}
